/**
 * Yjs CRDT Sync Types
 *
 * Defines types for Yjs synchronization, persistence, and metrics.
 * Used by both web client (SyncManager) and worker (Bootstrap API, Persist).
 *
 * @module types/yjs-sync
 * @see SPEC-008 Requirements 2.2, 3.2, 3.3, 4.2
 */
/**
 * Compression threshold for updates (bytes)
 * Updates larger than this should be compressed before transmission
 * @see SPEC-008 Requirement 2.8
 */
export const YJS_COMPRESSION_THRESHOLD = 1024;
/**
 * Default batch interval for rapid updates (ms)
 * @see SPEC-008 Requirement 2.7
 */
export const YJS_BATCH_INTERVAL_MS = 50;
/**
 * Snapshot trigger threshold - number of pending updates
 * @see SPEC-008 Requirement 5.1
 */
export const YJS_SNAPSHOT_UPDATE_THRESHOLD = 50;
/**
 * Snapshot trigger threshold - time since last snapshot (ms)
 * @see SPEC-008 Requirement 5.2
 */
export const YJS_SNAPSHOT_AGE_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes
//# sourceMappingURL=yjs-sync.js.map